import styled from '@emotion/styled';
import { Container } from '@presentation/components';
import { mediaQuery, responsiveFontSize } from '@presentation/styles';

export const HeadWrapper = styled.div`
  padding: 30px 20px;
  text-align: center;
`;

export const Title = styled.h1`
  ${responsiveFontSize(44, 4)}
  color: ${(props) => props.theme.color.blue.default};
  font-family: ${(props) => props.theme.font.alternate};
  font-weight: 600;
`;

export const Subtitle = styled.span`
  color: ${(props) => props.theme.color.blue.default};
  margin-top: 7px;
  ${responsiveFontSize(18)}
  font-weight: 500;
`;

export const ContentWrapper = styled.div`
  margin-top: 80px;
  position: relative;
  background-color: ${(props) => props.theme.color.blue.light};
  color: ${(props) => props.theme.color.blue.default};
  padding-top: 40px;
  padding-bottom: 40px;
  ${mediaQuery('tablet')} {
    margin-top: 40px;
  }
`;

export const TopDecoration = styled.img`
  position: absolute;
  left: 0;
  bottom: 99%;
  width: 100%;
  z-index: -1;
`;

export const DogDecorationWrapper = styled.div<{ right: boolean }>`
  position: absolute;
  height: 450px;
  z-index: 1;
  right: -60px;
  bottom: 0;

  left: ${(props) => (props.right ? 'auto' : '-60px')};
  right: ${(props) => (props.right ? '-60px' : 'auto')};

  p {
    margin: 0;
  }

  img {
    height: 100%;
    transform: ${(props) => (props.right ? 'none' : 'rotateY(180deg)')};
  }

  ${mediaQuery(1400)} {
    display: none;
  }
`;

export const DogInteraction = styled.div<{ active: boolean; right: boolean }>`
  position: absolute;
  bottom: 80%;
  width: 200px;
  transition: opacity 500ms ease-in-out;

  opacity: ${(props) => (props.active ? 1 : 0)};
  left: ${(props) => (props.right ? 'auto' : '74%')};
  right: ${(props) => (props.right ? '74%' : 'auto')};

  p {
    margin: 0;
  }

  img {
    width: 100%;
    transform: none;
  }
`;

export const DogInteractionText = styled.p`
  padding: 5px;
  ${responsiveFontSize(20)}
  font-family: ${(props) => props.theme.font.alternate};
  font-weight: 600;
  z-index: 1;
  color: ${(props) => props.theme.color.blue.default};
  position: absolute;
  display: block;
  width: 100%;
  text-align: center;
  top: 31%;
`;

export const ContentContainer = styled(Container)`
  position: relative;
`;

export const QuestionTitle = styled.div`
  ${responsiveFontSize(36, 3)}
  font-family: ${(props) => props.theme.font.alternate};
  font-weight: 600;

  height: 120px;
  max-width: 1000px;
  margin: auto;
  text-align: center;

  display: flex;
  justify-content: center;
  align-items: center;

  ${mediaQuery('tablet')} {
    height: auto;
  }
`;

export const AnswerContainer = styled.div`
  height: 240px;
  margin-top: 40px;
  display: flex;
  justify-content: center;
  align-items: flex-start;

  ${mediaQuery('tablet')} {
    margin-top: 40px;
    flex-wrap: wrap;
    height: auto;
  }
`;

export const Answer = styled.div<{ noImage: boolean; active: boolean; itemAmount: number }>`
  cursor: pointer;
  position: relative;

  border-radius: 10px;
  margin: 0 15px;

  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;

  padding: 0 25px;
  opacity: 0.8;

  color: ${(props) => props.theme.color.blue.default};
  background-color: ${(props) => props.theme.color.light.tint};
  border: 1px solid ${(props) => props.theme.color.blue.default};

  transition: opacity 0.4s ease;

  &:first-child {
    margin-left: 0;
  }
  &:last-child {
    margin-right: 0;
  }

  width: ${(props) => (props.itemAmount === 4 ? '250px' : '300px')};
  height: ${(props) => (props.noImage ? '130px' : '240px')};

  ${(props) =>
    props.active &&
    `
    font-weight: 600;
    opacity: 1;
    border: 3px solid ${props.theme.color.blue.default};
    `}

  ${mediaQuery('medium')} {
    padding: 0 20px;
  }
  ${mediaQuery('tablet')} {
    height: 100px;

    width: 100% !important;
    max-width: 300px;
    text-align: center;

    &.no-image {
      justify-content: center;
      height: 70px;
    }

    text-align: left;
    margin: 15px !important;
    padding: 18px;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
  }
`;

export const AnswerCheckWrapper = styled.div<{ active: boolean }>`
  position: absolute;
  top: -15px;
  left: 15px;

  width: 35px;
  height: 35px;
  border-radius: 100%;

  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 15px;
  transition: opacity 0.4s ease;

  background-color: ${(props) => props.theme.color.blue.default};
  color: ${(props) => props.theme.color.light.default};
  opacity: ${(props) => (props.active ? 1 : 0)};

  ${mediaQuery('tablet')} {
    width: 30px;
    height: 30px;
    left: 10px;
  }
`;

export const AnswerImage = styled.img<{ active: boolean }>`
  object-fit: contain;
  max-width: 100%;
  max-height: 110px;
  ${mediaQuery('tablet')} {
    max-height: 100%;
    margin-right: 30px;
  }
`;

export const AnswerText = styled.p<{ noImage: boolean }>`
  ${(props) =>
    props.noImage &&
    `
  margin: auto;
  `}

  margin-top: 14px;
  margin-bottom: 0;
  font-size: 16px;

  p {
    margin: 0;
  }

  ${mediaQuery('tablet')} {
    margin-top: 0;
    font-size: ${(props) => (props.noImage ? '16px' : '14px')};
  }

  ${mediaQuery('phone')} {
    margin-top: 0;
    font-size: ${(props) => (props.noImage ? '14px' : '13px')};
  }
`;

export const SkipWrapper = styled.div`
  margin-top: 20px;
  height: 40px;
  line-height: 40px;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SkipText = styled.div<{ active: boolean }>`
  transition: border 300ms ease;
  text-align: center;
  font-size: 16px;
  cursor: pointer;
  border-radius: 10px;
  padding: 0 20px;
  text-decoration: ${(props) => (props.active ? 'none' : 'none')};
  color: ${(props) =>
    props.active ? props.theme.color.blue.default : props.theme.color.medium.default};
  border: 2px solid
    ${(props) => (props.active ? props.theme.color.blue.default : props.theme.color.medium.tint)};
  background: ${(props) => (props.active ? props.theme.color.light.default : 'transparent')};
`;

export const NavigationContainer = styled.div`
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;

  ${mediaQuery('tablet')} {
    justify-content: space-between;
  }
`;

export const NavigationArrow = styled.div<{ disabled?: boolean; active?: boolean }>`
  width: 40px;
  height: 40px;
  border-radius: 100%;

  font-size: 18px;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  opacity: ${(props) => (props.disabled ? '0.7' : '1')};

  display: flex;
  justify-content: center;
  align-items: center;

  color: ${(props) =>
    props.active ? props.theme.color.light.default : props.theme.color.dark.shade};
  background-color: ${(props) =>
    props.active ? props.theme.color.blue.default : props.theme.color.light.default};

  ${(props) => props.active && 'box-shadow: 0 0 20px 0 #a3b5f0;'}
`;

export const NavigationText = styled.div`
  margin: 0 25px;
`;

export const HelpWrapper = styled.div`
  border-radius: 10px;

  padding: 14px 17px;
  margin: auto;
  margin-top: 30px;

  color: ${(props) => props.theme.color.blue.default};
  background-color: ${(props) => props.theme.color.blue.lightBlue};

  text-align: center;
  font-size: 16px;
  line-height: 1.5;
  max-width: 600px;
`;

export const HelpIcon = styled.span`
  vertical-align: text-bottom !important;
  font-size: 24px;
  margin-right: 9px;
  display: inline-block;
  height: 24px;
  margin-bottom: 2px;
`;
